// common constants
import moment from "moment";
const CURRENT_TIME_ZONE = Intl.DateTimeFormat({ timeZone: 'IST' }).resolvedOptions().timeZone;
const PARTNER_PROFILE_IMAGE = 'Partners/Images/ProfilePicture/';
const USER_PROFILE_PIC_PATH = 'Users/Images/ProfilePicture/';

const SYSTEM_USER_TYPES = {
    ADMIN: 1,
    PARTNER: 2,
    CLIENT: 3,
    ISV: 4,
    ISA: 5,
    REFERRAL: 6,
    USERMANAGEMENT: 7,
    ALTAIR_CLIENT: 8
};


const SHOW_BI_MODULES = {
    // *********** To hide modules ***********
    CUTOFF_DATE: "2024-08-01",
    FOR_OLD_CLIENT: (enrollmentDate) => {
        return moment(enrollmentDate).isBefore(this.CUTOFF_DATE);
    },
    FOR_ALL_CLIENT: false
}


const IS_SUBSCRIBE = {
    subscribe: 0,
    subscribed: 1,
}

const STIKKUM_PLAN_NAME = {
    ENHANCED: 'Enhanced',
    BASIC: 'Basic',
    BASIC_FOR_NEW_CLIENT: 'Basic For New Clients',
    PREMIUM: 'Premium',
    CUSTOM: 'Custom'
}
const ENROLL_LINK = {
    SPECIAL_ENROLL_LINK: '/specialenroll/',
    ISA_ENROLL_LINK: '/salesagent/',
    SAME_BILLING: '/samebilling/',
    DIFFERENT_BILLING: 'differentbilling/',
    ENROLL_LINK: '/enroll/'
}

const ACCESS_LOG_TYPE = {
    MARKETING_COMMUNICATION: 'Engage',
    REGISTRATION: 'Registration',
    FICO: 'Fico',
    SALES_REP_REGISTRATION: 'Sales Rep/ Agent Registration',
    LOGIN: 'Login',
}


const OWNER_LEVEL = {
    PRIMARY_USER: 'P',
    SECONDARY_USER: 'S',
    ROLE_BASED_USER: 'U',
}

const KEYWORD = {
    ADD: 'ADD',
    EDIT: 'EDIT',
    ALL: 'All',
    SELF: 'Self',
    CLIENT: 'Client'
}


const PRODUCT_TYPE = {
    STIKKUM_LO: 1,
    STIKKUM: 2,
}

const PAYMENT_GATE_WAY = {
    VELOX: 1,
    STRIPE: 2
}

const BILLING_ENTITY_TYPE = {
    SAME: 'S',
    DIFFERENT: 'D'
}



const ADMIN_ACTION = {
    CREATED_NEW_DATABASE: 'New Database created by Admin',
    DATABASE_DELETED: 'Database deleted by Admin',
    UPDATE_DATABASE_NAME: 'Database name updated by Admin',
    DATABASE_UPLOAD: 'Database uploaded by Admin',
    DATABASE_UPLOAD_AFTER_CORRECTION: 'Database uploaded after correction, Done by Admin',
    NEW_LEAD_ADDED_BY_ADMIN: 'New Contact added by Admin',
    LEAD_UPDATE_BY_ADMIN: 'Contact updated by Admin',
    LEADS_DELETED_BY_ADMIN: 'Contact deleted by Admin',
    LEAD_SNOOZE_BY_ADMIN: 'Contact snooze by Admin',
    PUSH_TO_OTHER_DATABASE: 'Transfer Contact to other database by Admin',
    UNDO_SNOOZE_BY_ADMIN: 'Contact Undo-Snooze by Admin',
    SELF_PULL_MARK_BY_ADMIN: 'Self pull mark by Admin',
    ALERT_DELETE_WITH_SELF_PULL_BY_ADMIN: 'Alert Delete with self pull by Admin',
    ALERT_DELETE_BY_ADMIN: 'Alert Delete by Admin',
    STOP_SCQUENCE_BY_ADMIN: 'Stop Scquence/Campaign by Admin',
    CREATED_BRANCH_WITH_SAME_BILLING: "Beanch created with same billing by Admin"
}

const MODULE_FOR_VIEW_LEAD = {
    default: 0,
    dashboard: 1,
    report: 2,
    database: 3,
    connect: 4
};

const ACTION_TYPE = {
    EDIT: 'edit',
    VIEW: 'view',
    ADD: 'add'
}

const BILLING_SUB_TYPE = {
    TOTAL: 1,
    TRANSACTION: 2,
    SUBSCRIPTION: 3,
}

const REPORT_BILLING_TYPE = {
    TOTAL_BILLING: 1,
    TRANSACTION_BILLING: 2,
    SUBSCRIPTION_BILLING: 3
}

const LOCATION_FOR = {
    STATE: 'state',
    CITY: 'city',
    ZIPCODE: 'zipcode'
}


const DEFAULT_OR_NEXT = {
    DEFAULT: 'Default',
    NEXT: 'Next',
}

const ROLE_TYPE = {
    ADMIN: 1,
    PARTNER: 2,
    CLIENT: 3,
    CLIENTLO: 4,
    ALTAIR: 5,
}

const ISV_PAYMENT_MODE = {
    SELF: 'S',
    CLIENT: 'C'
}


const HELP_TYPE = {
    FAQ: 'F',
    VIDEO: 'V',
    DOCUMENT: 'D'
}

const BOOLEAN = {
    TRUE: 'true',
    FALSE: 'false'
}


const BUDGET_PREFERENCE = {
    OVERALL: 1,
    SEPARATE: 2,
    NOT_SELECTED: 0,
    ALERT_BUDGET_ENABLED: 1
}

const BUDGET_RESET = {
    MONTH: 1,
    WEEK: 2,
    DAY: 3
}

const BUDGET_CONTROL = {
    PARENT: 1,
    CHILD: 2
}


const BUDGET_CATEGORY = {
    PERMANENT: 1,
    TEMPORARY: 2,
    POST_RESET_PERMANENT: 3
}

const SELECT_BUDGET_TYPE = {
    ACQUISITION: 1,
    RETENTION: 2,
    BOTH: 3
}

const COMMUNICATION_CATEGORY = {
    EMAIL: 'E',
    SMS: 'S',
    AUTO_SMS: 'AS',
    AUTO_EMAIL: 'AE',
    PARTNERSHIP_STATUS: 'PS',
    AUTO_SEQUENCE: 'ARS',
    CUSTOM_SMS: 'CS',
    CUSTOM_EMAIL: 'CE',
    SIGNATURE: 'SGN',
}


const STATUS = {
    PENDING: 1,
    SITE_INSPECTED: 2,
    ACTIVE: 3,
    INPROGRESS: 4,
    STABLE: 5,
    CLOSED_WON: 6,
    CLOSED_LOST: 7,
    APPROVED: 8,
    LEAD_DB_UPLOAD: 9,
    MONITORED: 10,
    PRODUCTION_LIVE: 11,
    INACTIVE: 12,
    REJECTED: 13,
    SENT: 14,
    RECEIVED: 15,
    SUCCESS: 16,
    FAILED: 17,
    TO_DELETE: 19,
    DELETED: 20,
    CLOSED: 21,
    APPROVED_SITE_INSPECTION_PENDING: 22,
    SNOOZE: 23,
    SNOOZED: 24,
    INCORRECT_DATA: 25,
    DUPLICATE_IN_SHEET: 26,
    DUPLICATE_IN_SYSTEM: 27,
    CORRECT_DATABASE: 28,
    EMPTY_DATABASE_FILE: 29,
    NOT_APPLICABLE: 30,
    UNLINK: 31,
    UNMONITORED: 32,
    NOT_CM: 33,
    DUPLICATE_IN_SAME_DATABASE: 34,
    CORRECT_DATA: 35,
    PROCESSING: 36,
    EPO_RISK_ALERT: 37,
}

const PRODUCT_SUBSCRIPTION_TYPE = {
    MONTH: 1,
    YEAR: 2,
}

const THIRD_PARTY_TYPES = {
    VERSE: 1,
    BOMBBOMB: 2,
    ZAPIER: 3,
    NORTH_TEXT: 4,
    VELOCIFY: 5,
    LEAD_MAIL_BOX: 6,
    MORTECH: 7,
    LODASOFT: 8,
    DAILY_AI: 9,
    OPEN_AI: 10,
    iLink: 13,
    RAD_CRM: 14,
    KONNECT: 17,
    PHONE_BURNER: 18,
    AWS: 11,
    iLink: 13,
    RAD_CRM: 14
};


const ALERT_TYPE_ID = {
    // NOT_LINK: 0,
    ACQUISITION: 1,
    RETENTION: 2,
    CREDIT_MONITORING: 3,
    ILINK: 4,
    HOME_BUYER: 5,
    PRE_MOVER_CONTACT: 6,
    PRE_MOVER_LIST: 7,
    NEW_MOVER: 8,
    NEWLY_MARRIED: 9,
    NEWLY_SINGLE: 10,
    PRENATAL: 11,
    NEW_BABY: 12,
    MORTGAGE_INTENT: 13,
    NEWLY_ENGAGED: 14,

    //& FAMILY 1 — Debt Monitoring
    TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE: 16,
    TOTAL_REVOLVING_BALANCE_ALERT_PRICE: 17,
    REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE: 18,
    OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE: 19,
    CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE: 20,

    //& FAMILY 2 — Installment & Auto Debt
    AUTO_LOAN_BALANCE_ALERT_PRICE: 21,
    AUTO_LEASE_BALANCE_ALERT_PRICE: 22,
    TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE: 23,
    OPEN_INSTALLMENT_COUNT_ALERT_PRICE: 24,
    HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE: 25,

    //& FAMILY 3 — Derogatory & Distress Signals
    THIRTY_DAY_DELINQUENCY_ALERT_PRICE: 26,
    SIXTY_DAY_DELINQUENCY_ALERT_PRICE: 27,
    NINETY_DAY_DELINQUENCY_ALERT_PRICE: 28,
    COLLECTIONS_ENTRY_ALERT_PRICE: 29,
    CHARGE_OFF_INDICATOR_ALERT_PRICE: 30,
    NEW_DEROGATORY_TRADE_ALERT_PRICE: 31,

    //& FAMILY 4 — Credit Health & Score Monitoring
    FICO_SCORE_DROP_ALERT_PRICE: 32,
    FICO_SCORE_BAND_CHANGE_ALERT_PRICE: 33,
    UTILIZATION_INCREASE_ALERT_PRICE: 34,
    TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE: 35,
    INQUIRY_CONCENTRATION_ALERT_PRICE: 36,
}


const IS_ALTAIR_VISIBLE_ALERT = {

    //& FAMILY 1 — Debt Monitoring
    TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE: false,
    TOTAL_REVOLVING_BALANCE_ALERT_PRICE: false,
    REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE: false,
    OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE: false,
    CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE: false,

    //& FAMILY 2 — Installment & Auto Debt
    AUTO_LOAN_BALANCE_ALERT_PRICE: false,
    AUTO_LEASE_BALANCE_ALERT_PRICE: false,
    TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE: false,
    OPEN_INSTALLMENT_COUNT_ALERT_PRICE: false,
    HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE: false,

    //& FAMILY 3 — Derogatory & Distress Signals
    THIRTY_DAY_DELINQUENCY_ALERT_PRICE: false,
    SIXTY_DAY_DELINQUENCY_ALERT_PRICE: false,
    NINETY_DAY_DELINQUENCY_ALERT_PRICE: false,
    COLLECTIONS_ENTRY_ALERT_PRICE: false,
    CHARGE_OFF_INDICATOR_ALERT_PRICE: false,
    NEW_DEROGATORY_TRADE_ALERT_PRICE: false,

    //& FAMILY 4 — Credit Health & Score Monitoring
    FICO_SCORE_DROP_ALERT_PRICE: false,
    FICO_SCORE_BAND_CHANGE_ALERT_PRICE: false,
    UTILIZATION_INCREASE_ALERT_PRICE: false,
    TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE: false,
    INQUIRY_CONCENTRATION_ALERT_PRICE: false,
}

const ALTAIR_ALERT_GROUPS = {
    TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE: "Debt Monitoring",
    TOTAL_REVOLVING_BALANCE_ALERT_PRICE: "Debt Monitoring",
    REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE: "Debt Monitoring",
    OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE: "Debt Monitoring",
    CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE: "Debt Monitoring",

    AUTO_LOAN_BALANCE_ALERT_PRICE: "Installment & Auto Debt",
    AUTO_LEASE_BALANCE_ALERT_PRICE: "Installment & Auto Debt",
    TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE: "Installment & Auto Debt",
    OPEN_INSTALLMENT_COUNT_ALERT_PRICE: "Installment & Auto Debt",
    HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE: "Installment & Auto Debt",

    THIRTY_DAY_DELINQUENCY_ALERT_PRICE: "Derogatory & Distress",
    SIXTY_DAY_DELINQUENCY_ALERT_PRICE: "Derogatory & Distress",
    NINETY_DAY_DELINQUENCY_ALERT_PRICE: "Derogatory & Distress",
    COLLECTIONS_ENTRY_ALERT_PRICE: "Derogatory & Distress",
    CHARGE_OFF_INDICATOR_ALERT_PRICE: "Derogatory & Distress",
    NEW_DEROGATORY_TRADE_ALERT_PRICE: "Derogatory & Distress",

    FICO_SCORE_DROP_ALERT_PRICE: "Credit Health & Score",
    FICO_SCORE_BAND_CHANGE_ALERT_PRICE: "Credit Health & Score",
    UTILIZATION_INCREASE_ALERT_PRICE: "Credit Health & Score",
    TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE: "Credit Health & Score",
    INQUIRY_CONCENTRATION_ALERT_PRICE: "Credit Health & Score",
};

const ALTAIR_ALERT_LABELS = {
    TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE: "Credit Card Balance Monitoring",
    TOTAL_REVOLVING_BALANCE_ALERT_PRICE: "Total Revolving Balance",
    REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE: "Total Revolving Debt Utilization Monitor",
    OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE: "Open Revolving Trade Count",
    CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE: "Credit Card Monthly Payment Burden",

    AUTO_LOAN_BALANCE_ALERT_PRICE: "Auto Loan Balance",
    AUTO_LEASE_BALANCE_ALERT_PRICE: "Auto Lease Balance",
    TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE: "Total Auto Monthly Payment",
    OPEN_INSTALLMENT_COUNT_ALERT_PRICE: "Open Installment Count Increase",
    HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE: "High Auto Balance Flag",

    THIRTY_DAY_DELINQUENCY_ALERT_PRICE: "30 Day Delinquency",
    SIXTY_DAY_DELINQUENCY_ALERT_PRICE: "60 Day Delinquency",
    NINETY_DAY_DELINQUENCY_ALERT_PRICE: "90 Day Delinquency",
    COLLECTIONS_ENTRY_ALERT_PRICE: "Collections Entry",
    CHARGE_OFF_INDICATOR_ALERT_PRICE: "Charge-Off Indicator",
    NEW_DEROGATORY_TRADE_ALERT_PRICE: "New Derogatory Trade",

    FICO_SCORE_DROP_ALERT_PRICE: "FICO Score Drop",
    FICO_SCORE_BAND_CHANGE_ALERT_PRICE: "FICO Score Band Change",
    UTILIZATION_INCREASE_ALERT_PRICE: "Utilization Increase",
    TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE: "Total Trade Count Increase",
    INQUIRY_CONCENTRATION_ALERT_PRICE: "Inquiry Concentration",
};
const IS_ALTAIR_VISIBLE_BY_ALERT_ID = {
    [ALERT_TYPE_ID.TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.TOTAL_REVOLVING_BALANCE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE]: false,

    [ALERT_TYPE_ID.AUTO_LOAN_BALANCE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.AUTO_LEASE_BALANCE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.OPEN_INSTALLMENT_COUNT_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE]: false,

    [ALERT_TYPE_ID.THIRTY_DAY_DELINQUENCY_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.SIXTY_DAY_DELINQUENCY_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.NINETY_DAY_DELINQUENCY_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.COLLECTIONS_ENTRY_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.CHARGE_OFF_INDICATOR_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.NEW_DEROGATORY_TRADE_ALERT_PRICE]: false,

    [ALERT_TYPE_ID.FICO_SCORE_DROP_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.FICO_SCORE_BAND_CHANGE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.UTILIZATION_INCREASE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE]: false,
    [ALERT_TYPE_ID.INQUIRY_CONCENTRATION_ALERT_PRICE]: false,
};


const ALTAIR_SUB_TYPE = {
    NOT_APPLICABLE: 0,
    ISIGHT: 1,
    ILIST: 2,
    MORTGAGE_GENERAL: 3,
    MORTGAGE_HELOC: 4,
    MORTGAGE_PURCHASE: 5,
    MORTGAGE_REFINANCE: 6,
    MORTGAGE_REVERSE: 7,
};
const REFERRAL_COMPENSATION_TYPE = {
    REVENUE_SHARE: {
        label: "Revenue Share",
        value: "R",
    },
    UNIT_BONUS: {
        label: "Unit Bonus",
        value: "U",
    },
};

const TIME_ZONE_OPTIONS = [
    { value: "US/Aleutian", label: "Hawaii Standard Time (HST)" },
    { value: "US/Alaska", label: "Alaska Daylight Time (AKDT)" },
    { value: "US/Central", label: "Central Standard Time (CST)" },
    { value: "US/Mountain", label: "Mountain Standard Time (MST)" },
    { value: "US/Pacific", label: "Pacific Standard Time (PST)" },
    { value: "US/Eastern", label: "Eastern Standard Time (EST)" },
    { value: "Asia/Calcutta", label: "Indian Standard Time (IST)" }
];

const US_TIME_ZONE_NAMES = {
    "US/Aleutian": "Hawaii Standard Time (HST)",
    "US/Alaska": "Alaska Daylight Time (AKDT)",
    "US/Central": "Central Standard Time (CST)",
    "US/Mountain": "Mountain Standard Time (MST)",
    "US/Michigan": "Eastern Standard Time (EST)",
    "US/East-Indiana": "Eastern Standard Time (EST)",
    "US/Indiana-Starke": "Eastern Standard Time (EST)",
    "US/Pacific": "Pacific Standard Time (PST)",
    "US/Pacific-New": "Pacific Standard Time (PST)",
    "US/Eastern": "Eastern Standard Time (EST)",
    "US/Arizona": "Mountain Standard Time (MST)",
    "Asia/Calcutta": "Indian Standard Time (IST)",
};

const ACCEPTED_TYPES = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/csv",
];

const DOCUMENT_TYPE = [
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
];

// AUTO RESPONSE CONSTANTS START

const COMMON_OPTION = [
    { label: 'All', value: 'ALL' },
    { label: 'Email', value: 8 },
    { label: 'SMS', value: 9 },
    { label: 'Campaign', value: 11 }
];


const ALTAIR_ATTRIBUTE_NAMES = {
    1: 'homeowner',
    2: 'VetHH_Flag',
    3: 'hispanic',
    4: 'probable_homeowner',
    5: 'income',
    6: 'SelfEmployed',
    7: 'biz_owner',
    8: 'home_biz',
    9: 'dwelling',
    10: 'MobileHomeInd',
    11: 'loan1_type',
    12: 'loan1_amount',
    13: 'loan1_balance',
    14: 'loan1_ratetype',
    15: 'interest_rate',
    16: 'home_value',
    17: 'reverse_mtg_flag',
    18: 'ltv',
    19: 'probable_homeowner',
    20: 'Status',
    21: 'list_price',
    27: 'location',
};


// AUTO RESPONSE CONSTANTS END


// BAHAVIOUR MONITORING CONSTANTS START

const STANDARD_OPTIONS = [
    { label: '{company}', value: 'company' },
    { label: '{salesRep/Agent}', value: 'salesRep/Agent' },
    { label: '{mainPointOfContact}', value: 'pointOfContact' },
    { label: '{personalInfo}', value: 'personalInfo' },
];

const ATTRIBUTE_TYPE_OPTIONS = [
    { label: 'Text', value: 'text' },
    { label: 'Date', value: 'date' },
    { label: 'Description', value: 'textarea' },
    { label: 'Number', value: 'range' },
    { label: 'Boolean', value: 'checkbox' }
];

const ILINK_DEFAULT_FIELDS = {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    mobileNumber: 'Mobile Number',
    address: 'Address',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code'
};

const ACTION_MODE = {
    add: 'Add',
    view: 'View',
    edit: 'Edit'
}


const PRICE_MAP = {
    [ALERT_TYPE_ID.HOME_BUYER]: "homebuyerAlertPrice",
    [ALERT_TYPE_ID.PRE_MOVER_LIST]: "premoverAtListAlertPrice",
    [ALERT_TYPE_ID.NEW_MOVER]: "newMoverAlertPrice",
    [ALERT_TYPE_ID.NEWLY_ENGAGED]: "newlyEngageAlertPrice",
    [ALERT_TYPE_ID.NEWLY_MARRIED]: "newlyMarriedPrice",
    [ALERT_TYPE_ID.NEWLY_SINGLE]: "newlySinglePrice",
    [ALERT_TYPE_ID.PRENATAL]: "prenatalAlertPrice",
    [ALERT_TYPE_ID.NEW_BABY]: "newBabyAlertPrice",
    [ALERT_TYPE_ID.MORTGAGE_INTENT]: "mortgageAlertPrice",
    [ALERT_TYPE_ID.CREDIT_MONITORING]: "value2",


    //& FAMILY 1 — Debt Monitoring
    [ALERT_TYPE_ID.TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE]: "totalCreditCardBalanceMonitorPrice",
    [ALERT_TYPE_ID.TOTAL_REVOLVING_BALANCE_ALERT_PRICE]: "totalRevolvingBalanceMonitorPrice",
    [ALERT_TYPE_ID.REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE]: "revolvingUtilizationSpikePrice",
    [ALERT_TYPE_ID.OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE]: "openRevolvingTradeCountPrice",
    [ALERT_TYPE_ID.CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE]: "creditCardMonthlyPaymentBurdenPrice",

    //& FAMILY 2 — Installment & Auto Debt
    [ALERT_TYPE_ID.AUTO_LOAN_BALANCE_ALERT_PRICE]: "autoLoanBalanceMonitorPrice",
    [ALERT_TYPE_ID.AUTO_LEASE_BALANCE_ALERT_PRICE]: "autoLeaseBalanceMonitorPrice",
    [ALERT_TYPE_ID.TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE]: "totalAutoMonthlyPaymentPrice",
    [ALERT_TYPE_ID.OPEN_INSTALLMENT_COUNT_ALERT_PRICE]: "openInstallmentCountIncreasePrice",
    [ALERT_TYPE_ID.HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE]: "highAutoBalanceFlagPrice",

    //& FAMILY 3 — Derogatory & Distress Signals
    [ALERT_TYPE_ID.THIRTY_DAY_DELINQUENCY_ALERT_PRICE]: "day30DelinquencySignalPrice",
    [ALERT_TYPE_ID.SIXTY_DAY_DELINQUENCY_ALERT_PRICE]: "day60DelinquencySignalPrice",
    [ALERT_TYPE_ID.NINETY_DAY_DELINQUENCY_ALERT_PRICE]: "day90DelinquencySignalPrice",
    [ALERT_TYPE_ID.COLLECTIONS_ENTRY_ALERT_PRICE]: "collectionsEntryPrice",
    [ALERT_TYPE_ID.CHARGE_OFF_INDICATOR_ALERT_PRICE]: "chargeOffIndicatorPrice",
    [ALERT_TYPE_ID.NEW_DEROGATORY_TRADE_ALERT_PRICE]: "newDerogatoryTradePrice",

    //& FAMILY 4 — Credit Health & Score Monitoring
    [ALERT_TYPE_ID.FICO_SCORE_DROP_ALERT_PRICE]: "ficoScoreDropMonitorPrice",
    [ALERT_TYPE_ID.FICO_SCORE_BAND_CHANGE_ALERT_PRICE]: "ficoScoreBandChangePrice",
    [ALERT_TYPE_ID.UTILIZATION_INCREASE_ALERT_PRICE]: "utilizationIncreaseMonitorPrice",
    [ALERT_TYPE_ID.TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE]: "totalTradeCountIncreasePrice",
    [ALERT_TYPE_ID.INQUIRY_CONCENTRATION_ALERT_PRICE]: "inquiryConcentrationSignalPrice",
};

const ALTAIR_COUNT_KEY_MAP = {
    TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE: "totalCreditCardBalanceAlert",
    TOTAL_REVOLVING_BALANCE_ALERT_PRICE: "totalRevolvingBalanceAlert",
    REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE: "revolvingUtilizationSpikeAlert",
    OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE: "openRevolvingTradeCountAlert",
    CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE: "creditCardMonthlyPaymentBurdenAlert",
    AUTO_LOAN_BALANCE_ALERT_PRICE: "autoLoanBalanceAlert",
    AUTO_LEASE_BALANCE_ALERT_PRICE: "autoLeaseBalanceAlert",
    TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE: "totalAutoMonthlyPaymentAlert",
    OPEN_INSTALLMENT_COUNT_ALERT_PRICE: "openInstallmentCountIncreaseAlert",
    HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE: "highAutoBalanceFlagAlert",
    THIRTY_DAY_DELINQUENCY_ALERT_PRICE: "day30DelinquencySignalAlert",
    SIXTY_DAY_DELINQUENCY_ALERT_PRICE: "day60DelinquencySignalAlert",
    NINETY_DAY_DELINQUENCY_ALERT_PRICE: "day90DelinquencySignalAlert",
    COLLECTIONS_ENTRY_ALERT_PRICE: "collectionsEntryAlert",
    CHARGE_OFF_INDICATOR_ALERT_PRICE: "chargeOffIndicatorAlert",
    NEW_DEROGATORY_TRADE_ALERT_PRICE: "newDerogatoryTradeAlert",
    FICO_SCORE_DROP_ALERT_PRICE: "ficoScoreDropAlert",
    FICO_SCORE_BAND_CHANGE_ALERT_PRICE: "ficoScoreBandChangeAlert",
    UTILIZATION_INCREASE_ALERT_PRICE: "utilizationIncreaseAlert",
    TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE: "totalTradeCountIncreaseAlert",
    INQUIRY_CONCENTRATION_ALERT_PRICE: "inquiryConcentrationSignalAlert",
};

const PREFERENCE_MAP = {
    [ALERT_TYPE_ID.CREDIT_MONITORING]: {
        smsDistribution: "alertDistributionSmsCM",
        emailCustomField: "customFieldsByEmailCM",
        smsCustomField: "customFieldsBySmsCM"
    },
    [ALERT_TYPE_ID.ILINK]: {
        smsDistribution: "alertDistributionSmsILink",
        emailCustomField: "customFieldsByEmailILink",
        smsCustomField: "customFieldsBySmsILink"
    },
    [ALERT_TYPE_ID.HOME_BUYER]: "dynamic",
    [ALERT_TYPE_ID.PRE_MOVER_LIST]: "dynamic",
    [ALERT_TYPE_ID.NEW_MOVER]: "dynamic",
    [ALERT_TYPE_ID.NEWLY_ENGAGED]: "dynamic",
    [ALERT_TYPE_ID.NEWLY_SINGLE]: "dynamic",
    [ALERT_TYPE_ID.MORTGAGE_INTENT]: "dynamic",

    //& FAMILY 1 — Debt Monitoring
    [ALERT_TYPE_ID.TOTAL_CREDIT_CARD_BALANCE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.TOTAL_REVOLVING_BALANCE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.REVOLVING_UTILIZATION_SPIKE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.OPEN_REVOLVING_TRADE_COUNT_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.CREDIT_CARD_MONTHLY_PAYMENT_ALERT_PRICE]: "altair",

    //& FAMILY 2 — Installment & Auto Debt
    [ALERT_TYPE_ID.AUTO_LOAN_BALANCE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.AUTO_LEASE_BALANCE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.TOTAL_AUTO_MONTHLY_PAYMENT_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.OPEN_INSTALLMENT_COUNT_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.HIGH_AUTO_BALANCE_FLAG_ALERT_PRICE]: "altair",

    //& FAMILY 3 — Derogatory & Distress Signals
    [ALERT_TYPE_ID.THIRTY_DAY_DELINQUENCY_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.SIXTY_DAY_DELINQUENCY_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.NINETY_DAY_DELINQUENCY_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.COLLECTIONS_ENTRY_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.CHARGE_OFF_INDICATOR_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.NEW_DEROGATORY_TRADE_ALERT_PRICE]: "altair",

    //& FAMILY 4 — Credit Health & Score Monitoring
    [ALERT_TYPE_ID.FICO_SCORE_DROP_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.FICO_SCORE_BAND_CHANGE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.UTILIZATION_INCREASE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.TOTAL_TRADE_COUNT_INCREASE_ALERT_PRICE]: "altair",
    [ALERT_TYPE_ID.INQUIRY_CONCENTRATION_ALERT_PRICE]: "altair",
};

const DYANAMIC_PREFERENCE_KEYS = {
    smsDistribution: "speedeOnDistributionForSms",
    emailCustomField: "speedeOnCustomFieldForEmail",
    smsCustomField: "speedeOnCustomFieldForSms"
};

const ALTAIR_PREFERENCE_KEYS = {
    smsDistribution: "altairDistributionForSms",
    emailCustomField: "altairCustomFieldForEmail",
    smsCustomField: "altairCustomFieldForSms"
}

const EXCEL_CSV_MIME_TYPES = [
    // Modern Excel
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template", // .xltx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",

    // Macro-enabled Excel
    "application/vnd.ms-excel.sheet.macroEnabled.12", // .xlsm
    "application/vnd.ms-excel.template.macroEnabled.12", // .xltm
    "application/vnd.ms-excel.addin.macroEnabled.12", // .xlam
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12", // .xlsb

    // Legacy Excel
    "application/vnd.ms-excel", // .xls
    "application/msexcel",
    "application/x-msexcel",
    "application/x-ms-excel",
    "application/x-excel",
    "application/x-dos_ms_excel",
    "application/xls",

    // CSV
    "text/csv",
    "application/csv",
    "application/x-csv",
    "text/x-csv",
    "text/comma-separated-values",

    // Sometimes Android/iOS returns generic types
    "application/octet-stream",
    "text/plain",

    // Rare / edge cases
    "application/vnd.ms-office",
    "application/zip", // sometimes .xlsx is detected as zip
];

const ACCEPTED_EXCEL_TYPES = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
    "application/vnd.ms-excel",
]

const ALL_FILE_TYPES = [
    // 🔹 Images
    "image/*",

    // 🔹 Videos
    "video/*",

    // 🔹 Audio
    "audio/*",

    // 🔹 Documents
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx

    // 🔹 Excel
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx

    // 🔹 PowerPoint
    "application/vnd.ms-powerpoint", // .ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx

    // 🔹 Text
    "text/plain",
    "text/html",
    "text/css",
    "text/javascript",
    "application/json",

    // 🔹 Archives
    "application/zip",
    "application/x-zip-compressed",
    "application/x-rar-compressed",
    "application/vnd.rar",
    "application/x-7z-compressed",
    "application/gzip",
    "application/x-tar",

    // 🔹 Generic fallback (VERY IMPORTANT)
    "application/octet-stream",

    ...EXCEL_CSV_MIME_TYPES
];

const EVENT_TYPE_ID = {
    Mortgage: 1,
    Home_Buyer: 5
}

const bundleName = {
    1: "StikkumLO",
    2: "Stikkum"
}

const MIME_TYPES = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',

    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

    csv: 'text/csv',
    txt: 'text/plain',

    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

    zip: 'application/zip',
    rar: 'application/vnd.rar',

    json: 'application/json'
};

const CONDITIONS = {
    MIN_CREDIT_SCORE: 300,
    MAX_CREDIT_SCORE: 850,
    MIN_PERCENTAGE: 1,
    MAX_PERCENTAGE:100,
}

export {
    SYSTEM_USER_TYPES,
    IS_SUBSCRIBE,
    STIKKUM_PLAN_NAME,
    PARTNER_PROFILE_IMAGE,
    USER_PROFILE_PIC_PATH,
    ACCESS_LOG_TYPE,
    OWNER_LEVEL,
    ENROLL_LINK,
    CURRENT_TIME_ZONE,
    ADMIN_ACTION,
    SHOW_BI_MODULES,
    ACTION_TYPE,
    SELECT_BUDGET_TYPE,
    BUDGET_CATEGORY,
    BUDGET_CONTROL,
    BUDGET_RESET,
    BUDGET_PREFERENCE,
    BOOLEAN,
    HELP_TYPE,
    ISV_PAYMENT_MODE,
    ROLE_TYPE,
    DEFAULT_OR_NEXT,
    LOCATION_FOR,
    REPORT_BILLING_TYPE,
    BILLING_SUB_TYPE,
    KEYWORD,
    MODULE_FOR_VIEW_LEAD,
    COMMUNICATION_CATEGORY,
    STATUS,
    PRODUCT_TYPE,
    PAYMENT_GATE_WAY,
    BILLING_ENTITY_TYPE,
    PRODUCT_SUBSCRIPTION_TYPE,
    THIRD_PARTY_TYPES,
    ALERT_TYPE_ID,
    IS_ALTAIR_VISIBLE_ALERT,
    ALTAIR_SUB_TYPE,
    REFERRAL_COMPENSATION_TYPE,
    TIME_ZONE_OPTIONS,
    US_TIME_ZONE_NAMES,
    ACCEPTED_TYPES,
    COMMON_OPTION,
    ALTAIR_ATTRIBUTE_NAMES,
    STANDARD_OPTIONS,
    ATTRIBUTE_TYPE_OPTIONS,
    ILINK_DEFAULT_FIELDS,
    ACTION_MODE,
    PRICE_MAP,
    PREFERENCE_MAP,
    DYANAMIC_PREFERENCE_KEYS,
    EVENT_TYPE_ID,
    bundleName,
    ALL_FILE_TYPES,
    EXCEL_CSV_MIME_TYPES,
    ACCEPTED_EXCEL_TYPES,
    MIME_TYPES,
    ALTAIR_ALERT_GROUPS,
    ALTAIR_ALERT_LABELS,
    ALTAIR_COUNT_KEY_MAP,
    DOCUMENT_TYPE,
    CONDITIONS,
    IS_ALTAIR_VISIBLE_BY_ALERT_ID,
    ALTAIR_PREFERENCE_KEYS
};
